import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, Validators, ValidatorFn, ValidationErrors} from '@angular/forms';
import { HostListener } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalContentComponent } from '../modal-content/modal-content.component';
import { ChartType } from 'chart.js';
import { Color } from 'ng2-charts';
import { MatSpinner } from '@angular/material/progress-spinner';
import { BodymodelService } from '../../services/bodymodel.service';
import { BaselineService } from '../../services/baseline.service';
import { DailyparamsService } from '../../services/dailyparams.service';
import { InterventionService } from '../../services/intervention.service';
import { ModalErrorComponent } from '../modal-error/modal-error.component';
import { RegisterService } from '../../services/register.service';
import { TextHelperService } from '../../services/text-helper.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';

import { PdfService } from '../../services/pdf.service';
import moment from 'moment';
import { BodychangeService } from 'src/app/services/bodychange.service';
import content from '../../../data/content.json';
import warnings from '../../../data/warnings.json';
import { faFlagCheckered, faUser, faWeight, faBullseye, faCalendarAlt, faUtensils, faChartPie, faPencilAlt, faExclamationTriangle  } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-calculator',
  templateUrl: './calculator.component.html',
  styleUrls: ['./calculator.component.scss']
})
export class CalculatorComponent implements OnInit {

  modalRef: any;
  warningRef: any;
  captchaID = '6LdBR5MUAAAAAHgstvl9erIkrUlmRvUu1qUXJkbd';
  captchaToken: string = '';

  BodyModel; baseline; dailyParams; bodyChange; intervention;// needs providers;

  faFlagCheckered = faFlagCheckered;
  faUser = faUser;
  faWeight = faWeight;
  faBullseye = faBullseye;
  faCalendarAlt = faCalendarAlt;
  faUtensils = faUtensils;
  faChartPie = faChartPie;
  faPencilAlt = faPencilAlt;
  faExclamationTriangle = faExclamationTriangle;

  constructor(
    private modalService: NgbModal,
    bodyModel: BodymodelService,
    baseline: BaselineService,
    Intervention: InterventionService,
    dailyParams: DailyparamsService,
    bodyChange: BodychangeService,
    private registerService: RegisterService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private PDF: PdfService,
    private textHelperService: TextHelperService,
    private fb: FormBuilder
  ) {
    this.BodyModel = bodyModel;
    this.baseline = baseline;
    this.dailyParams = dailyParams;
    this.bodyChange = bodyChange;
    this.intervention = Intervention;
  }

  trueProPathAllowed:boolean = false;
  vegPath:boolean = false;
  slideCheckCounter: number = 0;
  /* pro vars */
  clientLevelRadio: string = "level1";
  customMacroPercentages: boolean = false;
  customMacroPalms:boolean = false;
  customMacroGrams:boolean= false;
  calculateCustomMacros:boolean= false;

  custMacCalcCombo:string = 'ProteinCarb';
  custMacCalcGramPer:string = 'glb';
  custMacroCalcProtMultiplier:number;
  custMacroCalcCarbMultiplier:number;
  custMacroCalcFatMultiplier:number;

  customCalcProtGram: number;
  customCalcCarbGram: number;
  customCalcFatGram: number;
  customCalcProtPerc: number;
  customCalcCarbPerc: number;
  customCalcFatPerc: number;
  remainingCals: number;

  /* doughnut stuff */
  doughnutChartType: ChartType = 'doughnut';
  doughnutColors: any[] = [{ backgroundColor: ['#03BCE4', '#F4A238', '#FFE36A'] }];
  dietPreferenceDoughnutValues: number[] = [10,10,80];
  showTilda = 0;

  /* MACRO lookup chart */
  macro: any = {
    "Female": { "Lightly Active": { "Lose Weight": { "lowweight": { "highbf": "1", "midbf": "1", "lowbf": "1.1" }, "highweight": { "highbf": "0.6", "midbf": "1", "lowbf": "1.1" } }, "Build Muscle": { "lowweight": { "highbf": "1.1", "midbf": "1", "lowbf": "1.1" }, "highweight": { "highbf": "0.85", "midbf": "1", "lowbf": "1.1" } }, "Athletic Performance": { "lowweight": { "highbf": "1.05", "midbf": "1", "lowbf": "1.1" }, "highweight": { "highbf": "0.8", "midbf": "1", "lowbf": "1.1" } }, "Body Recomposition": { "lowweight": { "highbf": "1", "midbf": "1", "lowbf": "1.1" }, "highweight": { "highbf": "0.75", "midbf": "1", "lowbf": "1.1" } }, "Improve Health": { "lowweight": { "highbf": "0.9", "midbf": "0.9", "lowbf": "1" }, "highweight": { "highbf": "0.65", "midbf": "0.9", "lowbf": "1" } } }, "Moderately Active": { "Lose Weight": { "lowweight": { "highbf": "1.1", "midbf": "1.1", "lowbf": "1.2" }, "highweight": { "highbf": "0.7", "midbf": "1.1", "lowbf": "1.2" } }, "Build Muscle": { "lowweight": { "highbf": "1.2", "midbf": "1.1", "lowbf": "1.2" }, "highweight": { "highbf": "0.95", "midbf": "1.1", "lowbf": "1.2" } }, "Athletic Performance": { "lowweight": { "highbf": "1.15", "midbf": "1.1", "lowbf": "1.2" }, "highweight": { "highbf": "0.9", "midbf": "1.1", "lowbf": "1.2" } }, "Body Recomposition": { "lowweight": { "highbf": "1.1", "midbf": "1.1", "lowbf": "1.2" }, "highweight": { "highbf": "0.85", "midbf": "1.1", "lowbf": "1.2" } }, "Improve Health": { "lowweight": { "highbf": "1", "midbf": "1", "lowbf": "1.1" }, "highweight": { "highbf": "0.75", "midbf": "1", "lowbf": "1.1" } } }, "Highly Active": { "Lose Weight": { "lowweight": { "highbf": "1.2", "midbf": "1.2", "lowbf": "1.35" }, "highweight": { "highbf": "0.8", "midbf": "1.2", "lowbf": "1.35" } }, "Build Muscle": { "lowweight": { "highbf": "1.3", "midbf": "1.2", "lowbf": "1.35" }, "highweight": { "highbf": "1.05", "midbf": "1.2", "lowbf": "1.35" } }, "Athletic Performance": { "lowweight": { "highbf": "1.25", "midbf": "1.2", "lowbf": "1.35" }, "highweight": { "highbf": "1", "midbf": "1.2", "lowbf": "1.35" } }, "Body Recomposition": { "lowweight": { "highbf": "1.2", "midbf": "1.2", "lowbf": "1.35" }, "highweight": { "highbf": "0.95", "midbf": "1.2", "lowbf": "1.35" } }, "Improve Health": { "lowweight": { "highbf": "1.1", "midbf": "1.1", "lowbf": "1.2" }, "highweight": { "highbf": "0.85", "midbf": "1.1", "lowbf": "1.2" } } } }, "Male": { "Lightly Active": { "Lose Weight": { "lowweight": { "highbf": "1.05", "midbf": "1.05", "lowbf": "1.2" }, "highweight": { "highbf": "0.65", "midbf": "1.05", "lowbf": "1.2" } }, "Build Muscle": { "lowweight": { "highbf": "1.15", "midbf": "1.05", "lowbf": "1.2" }, "highweight": { "highbf": "0.9", "midbf": "1.05", "lowbf": "1.2" } }, "Athletic Performance": { "lowweight": { "highbf": "1.1", "midbf": "1.05", "lowbf": "1.2" }, "highweight": { "highbf": "0.85", "midbf": "1.05", "lowbf": "1.2" } }, "Body Recomposition": { "lowweight": { "highbf": "1.05", "midbf": "1.05", "lowbf": "1.2" }, "highweight": { "highbf": "0.8", "midbf": "1.05", "lowbf": "1.2" } }, "Improve Health": { "lowweight": { "highbf": "1", "midbf": "1", "lowbf": "1.1" }, "highweight": { "highbf": "0.75", "midbf": "1", "lowbf": "1.1" } } }, "Moderately Active": { "Lose Weight": { "lowweight": { "highbf": "1.2", "midbf": "1.2", "lowbf": "1.35" }, "highweight": { "highbf": "0.8", "midbf": "1.2", "lowbf": "1.35" } }, "Build Muscle": { "lowweight": { "highbf": "1.25", "midbf": "1.2", "lowbf": "1.35" }, "highweight": { "highbf": "1", "midbf": "1.2", "lowbf": "1.35" } }, "Athletic Performance": { "lowweight": { "highbf": "1.2", "midbf": "1.2", "lowbf": "1.35" }, "highweight": { "highbf": "0.95", "midbf": "1.2", "lowbf": "1.35" } }, "Body Recomposition": { "lowweight": { "highbf": "1.2", "midbf": "1.2", "lowbf": "1.35" }, "highweight": { "highbf": "0.95", "midbf": "1.2", "lowbf": "1.35" } }, "Improve Health": { "lowweight": { "highbf": "1.1", "midbf": "1.1", "lowbf": "1.2" }, "highweight": { "highbf": "0.85", "midbf": "1.1", "lowbf": "1.2" } } }, "Highly Active": { "Lose Weight": { "lowweight": { "highbf": "1.35", "midbf": "1.35", "lowbf": "1.5" }, "highweight": { "highbf": "0.95", "midbf": "1.35", "lowbf": "1.5" } }, "Build Muscle": { "lowweight": { "highbf": "1.35", "midbf": "1.35", "lowbf": "1.5" }, "highweight": { "highbf": "1.1", "midbf": "1.35", "lowbf": "1.5" } }, "Athletic Performance": { "lowweight": { "highbf": "1.3", "midbf": "1.35", "lowbf": "1.5" }, "highweight": { "highbf": "1.05", "midbf": "1.35", "lowbf": "1.5" } }, "Body Recomposition": { "lowweight": { "highbf": "1.35", "midbf": "1.35", "lowbf": "1.5" }, "highweight": { "highbf": "1.1", "midbf": "1.35", "lowbf": "1.5" } }, "Improve Health": { "lowweight": { "highbf": "1.2", "midbf": "1.2", "lowbf": "1.3" }, "highweight": { "highbf": "0.95", "midbf": "1.2", "lowbf": "1.3" } } } }
  };

  /* CALC - current vars for UI, should match original */
  heightUnitsGroup: string = "Inches";
  heightFt: number;
  heightIn: number;
  heightField: number;
  genderBox: string;
  genderPronouns: any = { 'Male':'his', 'Female':'her'};
  ageField: number;
  WorkActivityLevel: string;
  ExerciseLevel: string;
  dietaryPreference: string;
  macroPreference: string;
  customMacroAdjustType: string = "recommendations";
  goalPreference: string;
  initialWeightField: number;
  goalWeight: number;
  mealsPerDay: number;
  totalCustomPercent:number
  lastMacroSliderValue: number;
  lastSliderAdjustment: string;
  customProteinPercent: number;
  customCarbPercent: number;
  customFatPercent: number;
  customProteinGrams: number;
  customCarbGrams: number;
  customFatGrams: number;
  customProteinPalms: number;
  customCarbHandfuls: number;
  customFatThumbs: number;
  customFistsVeggies: number;
  customDietCalories: number;

  totalProtein: number;
  perMealProtein: number;
  totalCarbs: number;
  perMealCarbs: number;
  totalFats: number;
  perMealFats: number;
  totalFists: any;
  totalPalms: number;
  totalHandfuls: number;
  totalThumbs: number;
  perMealFists: string;
  perMealHandfuls: string;
  perMealThumbs: string;
  perMealPalms: string;

  finalCarbsPercentage: number;
  finalProteinPercentage: number;
  finalFatPercentage: number;

  lastPositiveProteinTransfer: string;
  lastNegativeProteinTransfer: string;

  dietVarsMapping = { protein: "customProteinPercent", carbs: "customCarbPercent", fat: "customFatPercent" };
  recommendedFoods = {
    protein: [], carbs: [], fat: [], veggies: []
  };

  dietMapping = {
    Anything: {
      validMacros: ["Balanced", "Low-carb", "Low-fat", "Custom input"],
      protein: {
        limits: {
          self: { low: 20, high: 45 },
          selfWithProCopy: { low: 20, high: 45 } ,
          pro: { low: 15, high: 50 },
        },
        foods: "Chicken, Tofu, Fish, Greek yogurt"
      },
      carbs: {
        limits: {
          self: { low: 20, high: 60 },
          selfWithProCopy: { low: 20, high: 60 } ,
          pro: { low: 15, high: 70 },
        },
        foods: "Beans, Blueberries, Sweet potatoes, Oats"
      },
      fat: {
        limits: {
          self: {  low: 20, high: 50 },
          selfWithProCopy: {  low: 20, high: 50 } ,
          pro: { low: 15, high: 50 },
        },
      foods: "Olive oil, Walnuts, Guacamole, Flax seeds"
      },
      veggies: { foods: "Spinach, Carrots, Cauliflower, Tomatoes"},
      print: {self: 5, pro: 7, macrosSpecifics:[21,22,23,24,25,26], selfWithProCopy: 7},
      min: 20, max: 60
    },
    Mediterranean: {
      validMacros: ["Balanced", "Low-carb", "Custom input"],
      protein: {
        limits: {
          self: { low: 20, high: 45},
          selfWithProCopy: {  low: 20, high: 45 } ,
          pro: { low: 15, high: 50 },
        },
        foods: "Fish, Chicken, Tofu, Greek yogurt"
      },
      carbs: {
        limits: {
          self: { low: 20, high: 50},
          selfWithProCopy: { low: 20, high: 50 } ,
          pro: { low: 15, high: 60 },
        },
        foods: "Beans, Blueberries, Sweet potatoes, Oats"
      },
      fat: {
        limits: {
          self: { low: 30, high: 55 },
          selfWithProCopy: { low: 30, high: 55 } ,
          pro: { low: 25, high: 60 },
        },
        foods: "Olive oil, Walnuts, Pesto, Cheese"},
      veggies: { foods: "Spinach, Carrots, Cauliflower, Tomatoes"},
      print: {self: 6, pro: 8, macrosSpecifics:[21,22,23,24,25,26], selfWithProCopy: 8},
      min: 20, max: 55
    },
    Paleo: {
      validMacros: ["Balanced", "Low-carb", "Custom input"],
      protein: {
        limits: {
          self: { low: 20, high: 45 },
          selfWithProCopy: { low: 20, high: 45 } ,
          pro: { low: 15, high: 50 },
        },
        foods: "Fish, Chicken, Red meat, Eggs"
      },
      carbs: {
        limits: {
          self: { low: 20, high: 50 },
          selfWithProCopy: { low: 20, high: 50 } ,
          pro: { low: 15, high: 50 },
        },
        foods: "Strawberries, Sweet potatoes, Purple potatoes, Oranges"
      },
      fat: {
        limits: {
          self: { low: 30, high: 60 },
          selfWithProCopy: { low: 30, high: 60 } ,
          pro: { low: 25, high: 60 },
        },
        foods: "Olive oil, Walnuts, Avocado, Coconut flakes"
      },
      veggies: { foods: "Spinach, Carrots, Cauliflower, Broccoli"},
      print: {self: 7, pro: 9, macrosSpecifics:[21,22,23,24,25,26], selfWithProCopy:9},
      min: 20, max: 60
    },
    Ketogenic: {
      validMacros: ["Very low-carb", "Custom input"],
      protein: {
        limits: {
          self: { low: 20, high: 35 },
          selfWithProCopy: { low: 20, high: 35 } ,
          pro: { low: 15, high: 35 },
        },
        foods: "Fatty fish, Duck, Red meat, Eggs"
      },
      carbs: {
        limits: {
          self: { low: 5, high: 15 },
          selfWithProCopy: { low: 5, high: 15 } ,
          pro: { low: 5, high: 15 },
        },
        foods: "Occasional Fruit, Occasional Starchy vegetables"
      },
      fat: {
        limits: {
          self: { low: 50, high: 75 },
          selfWithProCopy: { low: 50, high: 75 } ,
          pro: { low: 50, high: 80 },
        },
        foods: "Olive oil, Walnuts, Butter, Coconut oil"
      },
      veggies: { foods: "Spinach, Carrots, Cauliflower, Asparagus"},
      print: {self: 8, pro: 10, macrosSpecifics:[21,22,23,24,25,26], selfWithProCopy:10},
      min: 5, max : 75
    },
    Vegetarian: {
      validMacros: ["Balanced", "Low-carb", "Low-fat", "Custom input"],
      protein: {
        limits: {
          self: { low: 20, high: 45 },
          selfWithProCopy: { low: 20, high: 45 } ,
          pro: { low: 15, high: 50 },
        },
        foods: "Tempeh, Seitan, Eggs, Greek yogurt"
      },
      carbs: {
        limits: {
          self: { low: 20, high: 60 },
          selfWithProCopy: { low: 20, high: 60 } ,
          pro: { low: 15, high: 70 },
        },
        foods: "Beans, Blueberries, Sweet potatoes, Oats"
      },
      fat: {
        limits: {
          self: { low: 20, high: 50 },
          selfWithProCopy: { low: 20, high: 50 } ,
          pro: { low: 15, high: 50 },
        },
        foods: "Olive oil, Walnuts, Chia seeds, Avocado"
      },
      veggies: { foods: "Spinach, Carrots, Cauliflower, Tomatoes"},
      print: {self: 9, pro: 11, macrosSpecifics:[18,19,20,24,25,26], selfWithProCopy:11},
      min: 20, max: 60
    },
    "Fully Plant-Based": {
      validMacros: ["Low-fat", "Balanced", "Low-carb", "Very low-fat", "Custom input"],
      protein: {
        limits: {
          self: { low: 20, high: 35 },
          selfWithProCopy: { low: 20, high: 35 } ,
          pro: { low: 15, high: 35 },
        },
        foods: "Tempeh, Seitan, Tofu, Lentils"
      },
      carbs: {
        limits: {
          self: { low: 20, high: 70 },
          selfWithProCopy: { low: 20, high: 70 } ,
          pro: { low: 15, high: 75 },
        },
        foods: "Beans, Blueberries, Sweet potatoes, Oats"
      },
      fat: {
        limits: {
          self: { low: 10, high: 50 },
          selfWithProCopy: { low: 10, high: 50 } ,
          pro: { low: 10, high: 50 },
        },
        foods: "Olive oil, Walnuts, Chia seeds, Hemp seeds"
      },
      veggies: { foods: "Spinach, Carrots, Cauliflower, Tomatoes"},
      print: {self: 10, pro: 12, macrosSpecifics:[18,19,20,21,22,23], selfWithProCopy:12},
      min: 10, max: 70
    }
  }

  macroPercentageMapping = {
    "Balanced" : { protein: "30", carbs: "35", fat: "35"},
    "Low-fat" : { protein: "30", carbs: "50", fat: "20"},
    "Low-carb" : { protein: "30", carbs: "20", fat: "50"},
    "Very low-carb" : { protein: "20", carbs: "10", fat: "70"},
    "Very low-fat" : { protein: "20", carbs: "70", fat: "10"},
  };

  goalIntervention:any;
  dt;
  goalLowIntakeShow;
  lifestyleLowIntakeShow;

  unachievableGoal: boolean = false;
  goalMaintenanceIntervention:any;

  startingCalculated: boolean = false;
  usUnits: boolean = true;
  initialPALField;
  PALOverride:number;
  palCustEstToggle:string = 'true';


  goalProjection:any = {
    'Lose Weight' : {
      'Male' : [
        { from: null, to: null, fromFactor: 0.0025, toFactor: 0.0049, label: 'Comfortable', unit: 'weeks'},
        { from: null, to: null, fromFactor: 0.005, toFactor: 0.01, label: 'Reasonable', unit: 'weeks'},
        { from: null, to: null, fromFactor: 0.0101, toFactor: 0.015, label: 'Extreme', unit: 'weeks'}
      ],
      'Female' : [
        { from: null, to: null, fromFactor: 0.0025, toFactor: 0.0049, label: 'Comfortable', unit: 'weeks'},
        { from: null, to: null, fromFactor: 0.005, toFactor: 0.01, label: 'Reasonable', unit: 'weeks'},
        { from: null, to: null, fromFactor: 0.0101, toFactor: 0.015, label: 'Extreme', unit: 'weeks'}
      ]
    },
    'Build Muscle' : {
      'Male' : [
        { from: null, to: null, fromFactor: 0.015, toFactor: 0.01, label: 'Beginner', unit: 'months'},
        { from: null, to: null, fromFactor: 0.0075, toFactor: 0.005, label: 'Intermediate', unit: 'months'},
        { from: null, to: null, fromFactor: 0.00375, toFactor: 0.0025, label: 'Advanced', unit: 'months'}
      ],
      'Female' : [
        { from: null, to: null, fromFactor: 0.0075, toFactor: 0.005, label: 'Beginner', unit: 'months'},
        { from: null, to: null, fromFactor: 0.00375, toFactor: 0.0025, label: 'Intermediate', unit: 'months'},
        { from: null, to: null, fromFactor: 0.001875, toFactor: 0.00125, label: 'Advanced', unit: 'months'}
      ]
    }
  }

  multiplierRadioGroup: string = 'custom';
  int1: any;
  int1_onField: boolean;
  int1_sodiumAutoField: string;
  int1_dayField;
  int1_sodiumField: number;
  int1_carbInPercField: number;
  int1_palField: number;

  int2: any;
  int2_onField: boolean;
  int2_sodiumAutoField: string;
  int2_dayField;
  int2_sodiumField: number;
  int2_carbInPercField: number;
  int2_palField: number;

  minCal = 0;
  goalMaintCals;
  memorySelectionMaintenance;
  memorySelectionInt1_pal;
  memorySelectionInt2_pal;

  memorySelectionWeight;
  memorySelectionPAL;
  calorie_spread = 256; // 10% uncertainty
  weightunits = 2.20462;
  heightunits: number;

  InitialBfpField: number;
  initialBfpField2: number;
  initialBMIField: number;

  lastWeightUnitsRadioGroup = "lbs";
  weightUnitsRadioGroup = "lbs";
  energyUnitsRadioGroup = "Calories/day";

  weightRangeLow: number;
  weightRangeHigh: number;

  goalCheckBox = true;
  goalTime:number;// = 365;
  goalActChangeBox = 0;
  goalMaintenanceActChangeBox = 0;
  simulationLengthField = 365;
  rmrCalcAuto = "true"; //automatically calculate rmr
  bfpCalcAuto = "true"; //automatically calculate Bfp
  rmrCalcDisabled = true; //automatically calculate rmr
  bfpCalcDisabled = true; //automatically calculate Bfp
  //InitialBfpField = this.round10(baseline.bfp, -1);
  initialCarbInPercField;
  initialSodiumField;
  uncertaintyBox = 10;
  eps = .001;

  energyUnitsRadioGroupLbl: string;
  energyUnitsLblSrt: string;
  energyunits: number;
  maintCalsField: number;
  goalCalsField: number;
  goalMaintCalsField: number;
  initialRMRField: number;
  int1_calField: number;
  int2_calField: number;

  minDate: any;
  targetDate: any;
  today = new Date();

  baselineAdvancedCtl = false;
  lifestyleAdvancedCtl = false;

  customDietGrams = false;
  customDietFists = false;
  customDietPercent = false;

  // UI contact
  userName: string;
  userEmail: string;
  businessName: string;
  coachName: string;

  // UI variables
  pdfGenerationDone:boolean = false;

  /* global debug switch */
  debug: boolean = false;
  filteredMacroOptions: any[];

  startingSlide:string = "pathway";

  currentSlide: string;
  previousSlide: string;
  fullLogo: boolean;
  proResultsVisited: boolean = false;


  slideStack: string[] = [];
  progressStages: string[] = ["details", "goals", "diet", "activity", "results"];
  //ExerciseLevel, WorkActivityLevel
  palMap:any = {
    "Very Light" : {
      "Very Light": 1.4, "Light": 1.5, "Moderate": 1.6, "Heavy": 1.7
    },
    "Light" : {
      "Very Light": 1.5, "Light": 1.6, "Moderate": 1.7, "Heavy": 1.8
    },
    "Moderate" : {
      "Very Light": 1.6, "Light": 1.7, "Moderate": 1.8, "Heavy": 1.9
    },
    "Intense" : {
      "Very Light": 1.7, "Light": 1.8, "Moderate": 1.9, "Heavy": 2.1
    },
    "Very Intense": {
      "Very Light": 1.9, "Light": 2.0, "Moderate": 2.2, "Heavy": 2.3
    }
  }
  subtitle: string;
  title: string;
  caveat: string;
  showProgressBar: boolean = false;

  warningsData: any = warnings;
  contentData: any = content;

  calcPath: string;
  selfEdit: boolean = false;

  // acceptable values are pro, self, and selfWithProCopy
  activeLevel: string;

  logoFile: any;
  logoFileDisplay: string;

  // validators for pro email page
  validateWeight = (c: FormControl) => {
    return ((this.weightUnitsRadioGroup == 'lbs' && c.value >= 50 && c.value <= 500) ||
      (this.weightUnitsRadioGroup == 'kg' && c.value >= 23 && c.value <= 227)) ? null : {
      validateEmail: {
        valid: false
      }
    };
  }

  firstName = new FormControl('', [Validators.required]);
  clientFirstName = new FormControl('', [Validators.required]);
  coachFirstName = new FormControl('', [Validators.required]);
  companyName = new FormControl('', [Validators.required]);

  // validators for pro details page
  email = new FormControl('', [Validators.required, Validators.email]);
  weightRange = new FormControl('',[Validators.required, this.validateWeight]);
  feetRange = new FormControl('',[ Validators.min(2), Validators.max(9)]);
  inchRange = new FormControl('',[ Validators.min(0), Validators.max(11)]);
  ageRange = new FormControl('',[Validators.required, Validators.min(18), Validators.max(120)]);
  genderRange = new FormControl('', [Validators.required]);
  nameRequired = new FormControl('', [Validators.required]);
  cmRange = new FormControl('', [Validators.min(60), Validators.max(300)])
  rmrRange = new FormControl('',[Validators.min(500), Validators.max(5000)]);
  bfpRange = new FormControl('',[ Validators.min(3), Validators.max(65)]);

  proDetailsForm = new FormGroup({
    'nameRequired' : this.nameRequired,
    'weightRange' : this.weightRange,
    'ageRange' : this.ageRange,
    'genderRange' : this.genderRange,
    'feetRange' : this.feetRange,
    'inchRange' : this.inchRange,
    'cmRange' : this.cmRange,
    'rmrRange': this.rmrRange,
    'bfpRange': this.bfpRange
  });

  // validators for pro goals page

  validateGoal: ValidatorFn = (c: FormGroup): ValidationErrors | null => {
    /*const goalWeightControl = this.proGoalForm.get('goalWeightRange');
    if (this.goalPreference=='Lose Weight' || this.goalPreference=='Build Muscle') {
      goalWeightControl.setValidators
    }*/
    return (((this.goalPreference=='Lose Weight' || this.goalPreference=='Build Muscle') && this.targetDate && this.goalWeight) || (this.goalPreference!='Lose Weight' && this.goalPreference!='Build Muscle')) ? null : { 'goalValuesInvalid' : true};
  }

  proGoalForm = this.fb.group({
    goalRequired : [null, [Validators.required]],
    goalWeightRange : [null, [Validators.required]],
    targetDateControl: [null],
    lbsValidator: [null]
  })

  setLbKgValidators = () => {
    const lbsValidator = this.proGoalForm.get('lbsValidator');
    const goalWeightRange = this.proGoalForm.get('goalWeightRange');

    lbsValidator.valueChanges
      .subscribe( weightPref => {
        if (weightPref=='lbs') {
          goalWeightRange.setValidators([Validators.required, Validators.min(50),Validators.max(500),Validators.minLength(1)]);
        } else {
          goalWeightRange.setValidators([Validators.required, Validators.min(23),Validators.max(227),Validators.minLength(1)]);
        }
      })
  }

  setGoalWeightValidators = () => {
    const goalRequired = this.proGoalForm.get('goalRequired');
    const goalWeightRange = this.proGoalForm.get('goalWeightRange');
    const targetDateControl = this.proGoalForm.get('targetDateControl');

    goalRequired.valueChanges
      .subscribe(goalPref => {
        if (goalPref=='Lose Weight' || goalPref=='Build Muscle') {
          if (this.weightUnitsRadioGroup=='lbs') {
            goalWeightRange.setValidators([Validators.required, Validators.min(50),Validators.max(500),Validators.minLength(1)]);
          } else {
            goalWeightRange.setValidators([Validators.required, Validators.min(23),Validators.max(227),Validators.minLength(1)]);
          }

          targetDateControl.setValidators([Validators.required])
        } else {
          goalWeightRange.setValidators(null);
          //goalWeightRange.clearValidators();
          targetDateControl.setValidators(null)
        }
        goalWeightRange.updateValueAndValidity();
        targetDateControl.updateValueAndValidity();
      });
  }
  // pro activity validation
  proActivityForm = this.fb.group({
    activityPref: [null, [Validators.required]],
    exercisePref: [null, [Validators.required]],
    palRange: [null, [Validators.min(1.11), Validators.max(3)]],
    palCustEstToggleFC: ['true']
  });

  setPALOverrideValidators = () => {
    const palCustEstToggleFC = this.proActivityForm.get('palCustEstToggleFC');
    const palRange = this.proActivityForm.get('palRange');

    palCustEstToggleFC.valueChanges
      .subscribe(palCustEstPref => {
        if (palCustEstPref=='true') {
          palRange.disable();
        } else {
          palRange.enable();
        }
      });
  }

  // pro diet/macro validation
  proDietForm = this.fb.group({
    dietPref: [null, [Validators.required]],
    macroPref: [null, [Validators.required]],
    protPerc: [null],
    carbPerc: [null],
    fatPerc: [null], //totalCustomPercentFC: [null],
    protGrams: [null, [Validators.min(50),Validators.max(500)]],
    carbGrams: [null, [Validators.min(0),Validators.max(1000)]],
    fatGrams: [null,[Validators.min(25),Validators.max(500)]],
    protPalms: [null, [Validators.min(2),Validators.max(20)]],
    vegFists: [null, [Validators.min(1),Validators.max(20)]],
    carbHands: [null, [Validators.min(0),Validators.max(40)]],
    fatThumbs: [null, [Validators.min(0),Validators.max(40)]],
    mealsRange: [null, [Validators.required, Validators.min(1),Validators.max(8)]],
    custMacCalcComboFC: [null],
    custMacCalcGramPerFC: [null],
    custMacroCalcProtMultiplierFC: [null],
    custMacroCalcCarbMultiplierFC: [null],
    custMacroCalcFatMultiplierFC: [null],
    remainingCalsFC: [null,[Validators.required, Validators.min(-5)]]
  });

  setMacroValidators = () => {
    const macroPrefControl = this.proDietForm.get('macroPref');

    //const totalCustomPercentFC = this.proDietForm.get('totalCustomPercentFC');

    const protGramsControl = this.proDietForm.get('protGrams');
    const carbGramsControl = this.proDietForm.get('carbGrams');
    const fatGramsControl = this.proDietForm.get('fatGrams');

    const protPalmsControl = this.proDietForm.get('protPalms');
    const vegFistsControl = this.proDietForm.get('vegFists');
    const carbHandsControl = this.proDietForm.get('carbHands');
    const fatThumbsControl = this.proDietForm.get('fatThumbs');

    const custMacCalcComboFC = this.proDietForm.get('custMacCalcComboFC');
    const custMacCalcGramPerFC = this.proDietForm.get('custMacCalcGramPerFC');
    const custMacroCalcProtMultiplierFC = this.proDietForm.get('custMacroCalcProtMultiplierFC');
    const custMacroCalcCarbMultiplierFC = this.proDietForm.get('custMacroCalcCarbMultiplierFC');
    const custMacroCalcFatMultiplierFC = this.proDietForm.get('custMacroCalcFatMultiplierFC');
    const remainingCalsFC = this.proDietForm.get('remainingCalsFC');

    let updateCustomMacroStuff = (macroPref) => {
      protPalmsControl.setValidators(null);
      vegFistsControl.setValidators(null);
      carbHandsControl.setValidators(null);
      fatThumbsControl.setValidators(null);

      protGramsControl.setValidators(null);
      carbGramsControl.setValidators(null);
      fatGramsControl.setValidators(null);

      custMacroCalcProtMultiplierFC.setValidators(null);
      custMacroCalcCarbMultiplierFC.setValidators(null);
      custMacroCalcFatMultiplierFC.setValidators(null);
      remainingCalsFC.setValidators(null);
      //remainingCalsFC.disable();

      //totalCustomPercentFC.setValidators(null);

      if (macroPref === 'Enter Desired Macro Totals') {

        protGramsControl.setValidators([Validators.required, Validators.min(50),Validators.max(500)]);
        carbGramsControl.setValidators([Validators.required, Validators.min(0),Validators.max(1000)]);
        fatGramsControl.setValidators([Validators.required, Validators.min(25),Validators.max(500)]);

      } else if (macroPref === 'Enter Desired Hand Portions') {

        protPalmsControl.setValidators([Validators.required, Validators.min(2),Validators.max(20)]);
        vegFistsControl.setValidators([Validators.required, Validators.min(1),Validators.max(20)]);
        carbHandsControl.setValidators([Validators.required, Validators.min(0),Validators.max(40)]);
        fatThumbsControl.setValidators([Validators.required, Validators.min(0),Validators.max(40)]);

      } else if (macroPref === 'Customize Macro Grams') {
        if (custMacCalcComboFC.value == 'ProteinCarb') {
          custMacroCalcCarbMultiplierFC.enable();
          if (custMacCalcGramPerFC.value=='glb') {
            custMacroCalcProtMultiplierFC.setValidators([Validators.required,Validators.min(.55),Validators.max(1.5)]);
            custMacroCalcCarbMultiplierFC.setValidators([Validators.required,Validators.min(0),Validators.max(5.5)]);
          } else {
            custMacroCalcProtMultiplierFC.setValidators([Validators.required,Validators.min(1.2),Validators.max(3.3)]);
            custMacroCalcCarbMultiplierFC.setValidators([Validators.required,Validators.min(0),Validators.max(12)]);
          }
          custMacroCalcFatMultiplierFC.setValidators(null);
          custMacroCalcFatMultiplierFC.disable();
          custMacroCalcFatMultiplierFC.setValue(null);
        } else {
          custMacroCalcFatMultiplierFC.enable();
          if (custMacCalcGramPerFC.value=='glb') {
            custMacroCalcProtMultiplierFC.setValidators([Validators.required,Validators.min(.55),Validators.max(1.5)]);
            custMacroCalcFatMultiplierFC.setValidators([Validators.required,Validators.min(.2),Validators.max(2)]);
          } else {
            custMacroCalcProtMultiplierFC.setValidators([Validators.required,Validators.min(1.2),Validators.max(3.3)]);
            custMacroCalcFatMultiplierFC.setValidators([Validators.required,Validators.min(.4),Validators.max(4.5)]);
          }
          custMacroCalcCarbMultiplierFC.setValidators(null);
          custMacroCalcCarbMultiplierFC.disable();
          custMacroCalcCarbMultiplierFC.setValue(null);
        }
        //remainingCalsFC.enable();
        remainingCalsFC.setValidators([Validators.required, Validators.min(-5)]);
        //remainingCalsFC.disable();

      } else if (macroPref === 'Customize Macro Percentages') {

        //totalCustomPercentFC.setValidators([Validators.required,Validators.min(100),Validators.max(100)]);

      } else {

        macroPrefControl.setValidators([Validators.required, Validators.minLength(1)]);

      }

      protPalmsControl.updateValueAndValidity();
      vegFistsControl.updateValueAndValidity();
      carbHandsControl.updateValueAndValidity();
      fatThumbsControl.updateValueAndValidity();

      protGramsControl.updateValueAndValidity();
      carbGramsControl.updateValueAndValidity();
      fatGramsControl.updateValueAndValidity();

      custMacroCalcProtMultiplierFC.updateValueAndValidity();
      custMacroCalcCarbMultiplierFC.updateValueAndValidity();
      custMacroCalcFatMultiplierFC.updateValueAndValidity();
      remainingCalsFC.updateValueAndValidity();

      //totalCustomPercentFC.updateValueAndValidity();
      //macroPrefControl.markAsDirty();
    }

    macroPrefControl.valueChanges.subscribe( change => {
      updateCustomMacroStuff(change)
     });

    custMacCalcComboFC.valueChanges.subscribe( change => {
      updateCustomMacroStuff(macroPrefControl.value)
     });

    custMacCalcGramPerFC.valueChanges.subscribe( change => {
      updateCustomMacroStuff(macroPrefControl.value)
     });
  }


  ngOnInit() {
    var urlParams = new URLSearchParams(window.location.search);
    this.vegPath = urlParams.get('veg')? true : false;
    this.trueProPathAllowed = urlParams.get('truepro') || this.vegPath? true : false;

    if (this.vegPath) {
      this.contentData.diet.options = this.contentData.diet.options.filter( option => ["Vegetarian","Fully Plant-Based"].includes( option.value ))
    }

    if (this.trueProPathAllowed) {
      this.initiateProPathway();
    } else {
      this.setVisibleSlide(this.startingSlide, "left");
      this.currentSlide = this.startingSlide;
      this.setCommonTextAndWidgets();
      this.setProgress(this.startingSlide);
    }

    this.setGoalWeightValidators();
    this.setMacroValidators();
    this.setLbKgValidators();
    this.setPALOverrideValidators();

    // CALC INIT
    this.goalIntervention = new InterventionService( this.BodyModel );
    this.goalMaintenanceIntervention = this.goalIntervention;
    this.initialBfpField2 = this.round10(this.baseline.getBFP(), -1);
    this.initialBMIField = this.round10(this.baseline.getBMI(), -1);

    this.int1 = new InterventionService(this.BodyModel);
    this.int1.Intervention(90, 2000, 50, 0, 4000);
    this.int1_onField = true;
    this.int1_sodiumAutoField = "true";
    this.int1_dayField = this.int1.day;
    this.int1.setproportionalsodium(this.baseline);
    this.int1_sodiumField = Math.round(this.int1.sodium);
    this.int1_carbInPercField = this.int1.carbinpercent;
    this.int1_palField = this.int1.actchangepercent;

    this.int2 = new InterventionService(this.BodyModel)
    this.int2.Intervention(180, 2500, 50, 0, 4000);
    this.int2_onField = true;
    this.int2_sodiumAutoField = "true";
    this.int2_dayField = this.int2.day;
    this.int2.setproportionalsodium(this.baseline);
    this.int2_sodiumField = Math.round(this.int2.sodium);
    this.int2_carbInPercField = this.int2.carbinpercent;
    this.int2_palField = this.int2.actchangepercent;

    this.initialCarbInPercField = this.baseline.carbIntakePct;
    this.initialSodiumField = this.baseline.sodium;

    if (this.debug) {
      this.userName = "nate";
      this.userEmail = "cheryl+test@precisionnutrition.com"
      this.goalWeight = 170;
      this.initialWeightField = 180;
      this.genderBox = "Female";
      //this.ageField = this.baseline.age;
      //this.heightField = this.baseline.height; //in cm
      //this.initialPALField = this.baseline.pal;
      this.globalUnitsUS(true);
      this.changeHeightUnits();
      this.changeInitialWeightField();

      this.heightFt = 5;
      this.heightIn = 10;
      this.changeHeightFeet();
      //this.heightField = 178;
      this.ageField = 40;
      this.WorkActivityLevel = "Very Light";
      this.ExerciseLevel = "Intense";
      this.calculatePAL();
      this.dietaryPreference = "Anything";
      this.macroPreference = "Balanced";
      this.customMacroAdjustType = "recommendations";
      this.goalPreference = "Lose Weight";
      this.mealsPerDay = 3;
      //this.globalUnitsUS(true);
      this.calcPath = "pro";

      //this.PDF.downloadPDF(this.pdfTemplates[ this.calcPath ]);

      this.pdfGenerationDone = true;

      this.goalTime = 180;

      // if pro...
      //this.clientLevelRadio=='level2or3'
      this.setRecommendedFoods();
      this.PDF.downloadPDF(this.pdfTemplates[ this.calcPath ]);

      // use this for testing the "reset" functions when hitting X
      //setTimeout( this.onCloseCalculator, 1000 );
    }
    this.minDate = new Date();
    //this.targetDate = moment(new Date()).add(this.goalTime, 'days').toDate();

    this.changeWeightUnits();
    this.changeEnergyUnits();
    this.changeHeightUnits();

    this.goalChange(false);
  }

  skipSlide = (slide) => {
    return (slide && slide.skip) ? this[slide.skip]() : false;
  }

  goForward = (slide: string = null) => {
    let nextSlide = slide ? slide : this.contentData[this.currentSlide].next;

    if (typeof(nextSlide) == "object") nextSlide = nextSlide[this.calcPath];

    if (this.skipSlide(this.contentData[nextSlide])) {
      this.goForward(this.contentData[nextSlide].next);
      return;
    }

    if (this.contentData[nextSlide].preLoad) this[this.contentData[nextSlide].preLoad]();
    this.setVisibleSlide(nextSlide, "left");
    this.slideStack.push(this.currentSlide);
    /*
    if (this.contentData[this.currentSlide].mode == "client") {
      this.slideStack = [];
    }
    */
    this.currentSlide = nextSlide;
    this.setCommonTextAndWidgets();
    this.setProgress(nextSlide);

    if (this.contentData[nextSlide].postLoad) this[this.contentData[nextSlide].postLoad]();
  }

  goBackward = () => {
    let prevSlide = this.slideStack.pop();
    this.setVisibleSlide(prevSlide, "right");
    this.currentSlide = prevSlide;
    this.setCommonTextAndWidgets();
    this.setProgress(prevSlide);
  }

  setVisibleSlide = (slide, direction) => {
    const currentSlide = this.currentSlide;

    setTimeout(() => {
      if (currentSlide) {
        const currentEl = document.getElementById(currentSlide);
        currentEl.classList.remove('active');
        if (direction === 'left') { currentEl.classList.add('visited'); }
      }
      const nextEl = document.getElementById(slide);
      nextEl.classList.add('active');
      if (direction === 'right') { nextEl.classList.remove('visited'); }
      document.getElementById('stage').scrollTop = 0;
    }, 500);
  }

  interpolateCopy = (inputString) => {
    return inputString.replace(/\{\{(\w+)\|?(\w+)?\}\}/g, (match, variable, modifier) => {
      let returnString = this[variable];
      if (modifier) {
        returnString = this[modifier](returnString);
      }
      return returnString;
    });
  }
  setCommonTextAndWidgets = () => {
    let thisSlide = this.contentData[this.currentSlide];

    if ( thisSlide.replace ) {
      thisSlide[ thisSlide.replace.field ] = thisSlide.replace.template
        .replace( thisSlide.replace.text, this[thisSlide.replace.text] );
    }

    this.title = thisSlide.title || null;
    this.subtitle = thisSlide.subtitle || null;
    this.caveat = thisSlide.caveat || null;

    if (this.calcPath == "selfWithProCopy" && thisSlide.selfWithProCopy) {
      this.title = thisSlide.selfWithProCopy.title || this.title;
      this.subtitle = thisSlide.selfWithProCopy.subtitle || this.subtitle;
      this.caveat = thisSlide.selfWithProCopy.caveat || null;
    }

    if (this.calcPath == "pro" && thisSlide.proCopy) {
      this.title = thisSlide.proCopy.title ? this.interpolateCopy(thisSlide.proCopy.title) : this.title;
      this.subtitle = thisSlide.proCopy.subtitle || this.subtitle;
      this.caveat = thisSlide.proCopy.caveat || null;
    }

    //this.caveat = thisSlide.caveat || null;
    this.showProgressBar = thisSlide.stage ? true : false;
    this.fullLogo = (thisSlide.fullLogo || this.contentData[this.currentSlide].mode == 'client') ?
      true : false;

    if (thisSlide.onLoad) this[thisSlide.onLoad]();
  }

  onCloseCalculator = () => {
    this.userName = null;
    this.userEmail = null;
    this.businessName = null;
    this.goalWeight = null;
    this.initialWeightField = null;
    this.genderBox = null;
    this.ageField = null;
    this.heightField = null; //in cm
    this.initialPALField = null;
    this.PALOverride = null;

    this.heightFt = null;
    this.heightIn = null;
    this.heightField = null;

    this.WorkActivityLevel = null;
    this.ExerciseLevel = null;
    this.dietaryPreference = null;
    this.macroPreference = null;
    this.customMacroAdjustType = "recommendations";
    this.goalPreference = null;
    this.mealsPerDay = null;
    this.baselineChange();
    this.goForward('pathway');
    window.parent.postMessage({ "operation": "close" }, '*');
  }

  setProResultsVisited = () => {
    this.proResultsVisited = true;
  }
  setProgress = (slide) => {
    let thisSlide = this.contentData[slide];
    if (thisSlide.stage) {
      let percent = 100 * ((this.progressStages.indexOf(thisSlide.stage) + 1) / this.progressStages.length);
      this.setProgressBarWidth(percent);
    }
  }

  generateDietPreferenceDoughnutValues = () => {
    let option = this.contentData.macros.options
      .filter( op => op.value == this.dietMapping[this.dietaryPreference].validMacros[0] )[0];
    this.dietPreferenceDoughnutValues = [ option.protein, option.carbs, option.fats ];
    this.showTilda = option.tilda;
  }

  setProgressBarWidth = (width: number) => {
    setTimeout(() => {
      let progressBar = document.getElementById("progressBar");
      progressBar.style.width = width + "%";
    }, 15);
  }

  showModal = (item: any) => {
    if (this.modalRef) {
      this.modalRef.close();
    }

    this.modalRef = this.modalService.open(ModalContentComponent, { centered: true, windowClass: "calcModal" });
    this.modalRef.componentInstance.item = item;
    this.modalRef.componentInstance.path = this.calcPath;
  }

  getGenderModal = () => {
    return this.contentData["sex"].modal;
  }

  /*
  ! Calculation Stuff
   */

  selfGenderChange = (sex: string) => {
    this.genderChange(sex);

    setTimeout(() => {
      this.goForward();
    }, 100);
  }

  genderChange = (sex: string) => {
    if (sex) this.genderBox = sex;

    this.baseline.isMale = (this.genderBox === "Male") ? true : false;
    this.baselineChange();
    this.updateGoalProjections();
    this.goalChange(false);
  }

  decimalAdjust = (type, value, exp) => {
    // If the exp is undefined or zero...
    if (typeof exp === 'undefined' || +exp === 0) {
      return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // If the value is not a number or the exp is not an integer...
    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
      return NaN;
    }
    // Shift
    value = value.toString().split('e');
    value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
  }

  round10 = function (value, exp) {
    return this.decimalAdjust('round', value, exp);
  }

  floor10 = function (value, exp) {
    return this.decimalAdjust('floor', value, exp);
  }

  ceil10 = function (value, exp) {
    return this.decimalAdjust('ceil', value, exp);
  };

  globalUnitsUS = (isUS) => {
    if (isUS) {
      this.weightUnitsRadioGroup = "lbs";
      this.heightUnitsGroup = "Inches";
      this.energyUnitsRadioGroup = "Calories/day";
    } else {
      this.weightUnitsRadioGroup = "kg";
      this.heightUnitsGroup = "Centimeters";
      this.energyUnitsRadioGroup = "Kilojoules/day";
    }
    if (this.usUnits != isUS) {
      this.usUnits != isUS;
      this.changeWeightUnits();
      this.changeHeightUnits();
      this.changeEnergyUnits();
    }
  }


  changeInitialWeightField = () => {
    if (this.weightUnitsRadioGroup == "lbs") {
        this.baseline.weight = this.initialWeightField / this.weightunits;
    } else {
        this.baseline.weight = this.initialWeightField * 1
    }
    //this.goalWeight = this.initialWeightField;
    this.baselineChange();
    this.updateGoalProjections();
    this.goalChange(false);
  }

  changeWeightUnits = () => {
    let weightUnitsMap = { lbs: 2.20462, kg: 1 }

    this.weightunits = weightUnitsMap[this.weightUnitsRadioGroup];

    let thisConversion = weightUnitsMap[this.weightUnitsRadioGroup] / weightUnitsMap[this.lastWeightUnitsRadioGroup];

    this.lastWeightUnitsRadioGroup = this.weightUnitsRadioGroup;

    if (this.initialWeightField) {
      this.initialWeightField = Math.round(this.baseline.weight * weightUnitsMap[this.weightUnitsRadioGroup]);

      if (this.weightUnitsRadioGroup == 'lbs' && this.initialWeightField > 500) {
        this.initialWeightField = 500;
      } else if (this.weightUnitsRadioGroup == 'kg' && this.initialWeightField < 23) {
        this.initialWeightField = 23;
      }
    }

    this.goalWeight = Math.round(this.goalWeight * thisConversion);

    var healthyWeightRange = this.baseline.getHealthyWeightRange();
    this.weightRangeLow = Math.floor(healthyWeightRange.low * this.weightunits);
    this.weightRangeHigh = Math.ceil(healthyWeightRange.high * this.weightunits);

    //this.goalChange();
  }

  changeHeightUnits = () => {
    if (this.heightUnitsGroup == "Inches") {
      this.heightunits = 0.3937;
    } else {
      this.heightunits = 1;
    }
    if (this.heightField) {
      this.heightField = Math.round(this.baseline.height * this.heightunits);
      this.convertHeightValue();
    }

  }

  changeHeightField = () => {
    if (this.heightUnitsGroup == "Inches") {
      this.baseline.height = this.heightField / this.heightunits;
      this.convertHeightValue();
    } else {
      this.baseline.height = this.heightField * 1
    }

    this.baselineChange();
    this.goalChange(false);
  }

  changeHeightFeet = () => {
    // if either ft or in were touched initialize the other to 0 to avoid bad math down the line
    this.heightFt = this.heightFt || 0;
    this.heightIn = this.heightIn || 0;

    let inches = this.heightFt * 12 + this.heightIn;
    this.heightField = Math.round(inches);
    this.changeHeightField();
  }

  convertHeightValue = () => {
    if (this.heightUnitsGroup == 'Inches') {
      //set ft/inches in the mask
      let inches = this.baseline.height * this.heightunits;
      let feet = Math.floor(inches / 12);
      inches %= 12;
      inches = Math.round(inches);
      if (inches == 12) {
        inches = 0;
        feet += 1;
      }
      this.heightFt = feet;
      this.heightIn = inches;
    }
  }

  changeMeals = () => {
    if (this.mealsPerDay < 1) {
      this.mealsPerDay = 1;
    } else if (this.mealsPerDay > 8) {
      this.mealsPerDay = 8;
    }
  }

  updateMacroOptions = () => {
    this.getMacroOptions();
    this.goForward();
  }

  goalChange = (withWarnings:boolean = true) => {
    if (
      //this.macroPreference &&
      this.initialWeightField &&
      this.genderBox &&
      this.ageField &&
      this.heightField &&
      this.initialPALField
      ) {

      this.customDietGrams = false;
      this.customDietFists = false;
      this.customDietPercent = false;
      //this.enableCalculateCustomMacros
      var healthyWeightRange = this.baseline.getHealthyWeightRange();
      this.weightRangeLow = Math.floor(healthyWeightRange.low * this.weightunits);
      this.weightRangeHigh = Math.ceil(healthyWeightRange.high * this.weightunits);

      //hide lifestyle warning
      this.goalLowIntakeShow = false;
      this.lifestyleLowIntakeShow = false;
      //this.dt = moment(new Date()).add(this.goalTime, 'days').format('M/D/YYYY');
      this.goalTime = moment(this.targetDate).diff(new Date(), 'days') + 1;

      if (this.goalTime > 365) {
        this.simulationLengthField = this.goalTime + 14;
      }

      this.goalIntervention = new InterventionService(this.BodyModel);
      this.goalMaintenanceIntervention = this.goalIntervention;
      if (this.goalPreference == "Lose Weight") {
        this.goalMaintenanceIntervention.actchangepercent = this.goalMaintenanceActChangeBox;
      }

      let calcGoalWeight:number;  //nvs always use gk?
      // nvs- why do this??  do we always calculate in kg??

      if (!this.goalWeight || isNaN(this.goalWeight) ||
      ['Athletic Performance','Body Recomposition','Improve Health'].includes(this.goalPreference)) {
        if (this.weightUnitsRadioGroup == "lbs") {
          this.goalWeight = this.baseline.weight * this.weightunits;
        } else {
          this.goalWeight = this.baseline.weight;
        }
      }

      if (this.weightUnitsRadioGroup == "lbs") {
        calcGoalWeight = this.goalWeight / this.weightunits;
      } else {
        calcGoalWeight = this.goalWeight;
      }


      //elliminate rounding errors due to convertion of units
      //nvs this makes no sense if baseline stays in kg
      if (Math.abs(calcGoalWeight - this.baseline.weight) < .02) {
        calcGoalWeight = this.baseline.weight;
      }

      try {
        let goalIntervention = new InterventionService(this.BodyModel);
        this.goalIntervention = goalIntervention.forgoal(this.baseline, calcGoalWeight, this.goalTime, this.goalActChangeBox, this.minCal, this.eps);
        this.unachievableGoal = false;
      } catch (err) {
        //if (!this.unachievableGoal) {
          this.unachievableGoal = true;

          //this.goalCalsField = 0;

          if (withWarnings) this.launchDialog("unachievableGoal");
          // setTimeout( function() {
          //   this.unachievableGoal = false;
          // }, 1000);
        //}
      }

      //if (!this.unachievableGoal) {
        switch (this.goalPreference) {
          case ('Athletic Performance'):
            this.maintCalsField = Math.round(this.baseline.getMaintCals() * this.energyunits * 1.1);
            this.goalCalsField = Math.round(this.goalIntervention.calories * this.energyunits * 1.1);
            break;
          case ('Body Recomposition'):
            this.maintCalsField = Math.round(this.baseline.getMaintCals() * this.energyunits * .9);
            this.goalCalsField = Math.round(this.goalIntervention.calories * this.energyunits * .9);
            break;
          default:
            this.maintCalsField = Math.round(this.baseline.getMaintCals() * this.energyunits);
            this.goalCalsField = Math.round(this.goalIntervention.calories * this.energyunits);
            break;
        }
      //}



      //We find out what the body composition will be at the goal time with the RKlast_ecw function
      let goalbc = new BodymodelService(this.dailyParams, this.bodyChange);
      goalbc = goalbc.projectFromBaselineViaIntervention(this.baseline, this.goalIntervention, this.goalTime + 1);
      var weightAtGoal = this.baseline.getNewWeightFromBodyModel(goalbc);
      var bfpAtGoal = goalbc.getFatPercent(this.baseline);

      //The goal body comp is used to calculated the calories needed to keep tissue from changing. However, it does not account for
      //the sodium needed to stabilize the extracellular water.
      if (calcGoalWeight == this.baseline.weight && this.goalMaintenanceIntervention.actchangepercent == 0) {
        this.goalMaintCals = this.baseline.getMaintCals();
      } else {
        this.goalMaintCals = goalbc.cals4balance(this.baseline, this.goalMaintenanceIntervention.getAct(this.baseline));
      }

      //If the user has changed the maintenance activity level, we may get a negative result, so we check and redo if needed
      /*
      if (this.goalMaintCals < 0) {
        this.launchDialog("notifyNegativeMaintCals");
        this.undo();
      }
      */

      if (calcGoalWeight != this.initialWeightField && (this.goalIntervention.calories < 1000 || this.goalMaintCals < 1000)) {
        //if (this.guidedStep != 0) {
        if (true) {
          //this.launchDialog("notifyNegativeMaintCals");
          calcGoalWeight = this.initialWeightField;
        } else {
          //expert mode
          this.goalLowIntakeShow = true;
        }
      }

      this.goalMaintenanceIntervention.day = this.goalTime + 1;
      this.goalMaintenanceIntervention.calories = this.goalMaintCals;
      this.goalMaintenanceIntervention.carbinpercent = this.baseline.carbIntakePct;
      this.goalMaintenanceIntervention.setproportionalsodium(this.baseline);

      this.goalMaintCalsField = Math.round(this.goalMaintenanceIntervention.calories * this.energyunits);

      //nvs
      this.macroPortionChange(withWarnings);

    }
  };

  launchDialog = (warningKey: string) => {
    this.warningRef = this.modalService.open( ModalErrorComponent, { centered: true, windowClass: "calcModal", backdropClass: this.warningsData[warningKey].color });
    this.warningRef.componentInstance.warningCopy = eval(this.warningsData[warningKey].copy);
  }


  calculatePAL = () => {
    if (this.ExerciseLevel && this.WorkActivityLevel) {
      this.PALOverride = this.initialPALField = this.baseline.pal = this.palMap[this.ExerciseLevel][this.WorkActivityLevel];
    }
    this.baselineChange();
    this.goalChange(false);
  }

  overridePAL = () => {
    this.initialPALField = this.PALOverride;
    this.baselineChange();
    this.goalChange(false);
  }

  changePalCustEstToggle = () => {
    if (this.palCustEstToggle) {
      this.calculatePAL();
    }
  }

  macroPortionChange = (withWarnings:boolean = true) => {
    if (!this.mealsPerDay || !this.macroPreference) return;
    let highWeightVal = 250;
    if (this.goalPreference == 'Lose Weight') {
      highWeightVal = 325;
    }

    var weightTransform = { "lbs": 1, "kg": 2.20462 };
    let weightToUse = this.initialWeightField * weightTransform[this.weightUnitsRadioGroup];

    this.activeLevel = (this.initialPALField >= 2) ? "Highly Active" :
      (this.initialPALField >= 1.7) ? "Moderately Active" : "Lightly Active";

    let weightCategory = (weightToUse < 126) ? "lowweight" :
      (weightToUse > highWeightVal) ? "highweight" : "midweight";

    let getProtein = () => {
      var protein = null;
      if (this.genderBox && this.activeLevel && this.goalPreference) {
        var userRangeBlock = this.macro[this.genderBox][this.activeLevel][this.goalPreference];
        var protein = null,
          customBF = false,
          BFCategory = "highbf";

        if ((this.goalPreference == 'Body Recomposition' ||
          this.goalPreference == 'Lose Weight' ||
          this.goalPreference == 'Improve Health') &&
          this.clientLevelRadio == 'level2or3' &&
          !isNaN(this.InitialBfpField)) {
          customBF = true;
          if (this.genderBox == "Male") {
            BFCategory = (this.InitialBfpField > 15) ? "highbf" : (this.InitialBfpField < 10) ? "lowbf" : "midbf";
          } else {
            BFCategory = (this.InitialBfpField > 22) ? "highbf" : (this.InitialBfpField < 17) ? "lowbf" : "midbf";
          }
        }
        if (BFCategory == "highbf") {
          if (userRangeBlock[weightCategory]) {
            protein = weightToUse * +userRangeBlock[weightCategory][BFCategory];
          } else {
            protein = (userRangeBlock.lowweight.highbf - ((weightToUse - 125) * 0.00198)) * weightToUse;
          }
        } else {
          protein = weightToUse * +userRangeBlock["lowweight"][BFCategory];
        }

      }
      return protein;
    }

    let mpd = +this.mealsPerDay;
    let normProtein = getProtein();
    let fats = 0, carbs = 0, normProteinCals = 0;

    normProteinCals = Math.round(normProtein * 4);
    // 4 calories per gram of protein, 4 calories per gram of carbs, 9 calories per gram of fats

    let minusProteinCals = this.goalCalsField - normProteinCals;
    if (minusProteinCals < 0) {
      // minusProteinCals = 0;
      // normProteinCals = 0;
    }

    if (this.customMacroAdjustType == "recommendations") {
      switch (this.macroPreference) {
        case ('Balanced'):
          // fix fats at 35%
          // fill remaining with carbs

          fats = Math.round((minusProteinCals / 2) / 9);
          carbs = Math.round((minusProteinCals / 2) / 4);
          break;
        case ('Low-fat'):
          // fix fats at 20%
          // fill remaining with carbs
          fats = Math.round((.20 * this.goalCalsField) / 9);
          carbs = Math.round((this.goalCalsField - (.20 * this.goalCalsField) - normProteinCals) / 4);
          break;
        case ('Low-carb'):
          // fix carbs at 20%
          // fill remaining with fats
          carbs = Math.round((.20 * this.goalCalsField) / 4);
          fats = Math.round((this.goalCalsField - (.20 * this.goalCalsField) - normProteinCals) / 9);
          break;
        case ('Very low-carb'): //(~20/10/70) prot/carb/fat
          normProtein = Math.round((.20 * this.goalCalsField) / 4);
          carbs = Math.round((.10 * this.goalCalsField) / 4);
          fats = Math.round((.70 * this.goalCalsField) / 9);
          break;
        case ('Very low-fat'): //(~20/70/10) prot/carb/fat
          normProtein = Math.round((.20 * this.goalCalsField) / 4);
          carbs = Math.round((.70 * this.goalCalsField) / 4);
          fats = Math.round((.10 * this.goalCalsField) / 9);
          break;
        case ('Custom input'):

          break;
      }
    } else {  // custom percentage input, "own"

      if (((this.customMacroAdjustType == "own" && this.calcPath == "self") || this.customMacroPercentages) && this.customProteinPercent && this.customCarbPercent && this.customFatPercent) {

        normProtein = Math.round((.01 * this.customProteinPercent * this.goalCalsField) / 4);
        carbs = Math.round((.01 * this.customCarbPercent * this.goalCalsField) / 4);
        fats = Math.round((.01 * this.customFatPercent * this.goalCalsField) / 9);

        this.customDietPercent = true;
      } else if (this.customMacroGrams &&this.customProteinGrams && this.customCarbGrams && this.customFatGrams) {
        normProtein = this.customProteinGrams;
        carbs = this.customCarbGrams;
        fats = this.customFatGrams;

        this.customDietCalories = (normProtein * 4) + (carbs * 4) + (fats * 9);

        this.customProteinPercent = Math.round((4 * normProtein) / (.01 * this.customDietCalories));
        this.customCarbPercent = Math.round((4 * carbs) / (.01 * this.customDietCalories));
        this.customFatPercent = Math.round((9 * fats) / (.01 * this.customDietCalories));

        this.customDietGrams = true;
      } else if (this.customMacroPalms && this.customProteinPalms && this.customCarbHandfuls && this.customFatThumbs) {
        // reverse rules - start with hand portions and calculate protein/fats/carbs
        if (this.genderBox == "Female") {
          normProtein = (22 * this.customProteinPalms) + ((this.customFistsVeggies * 1.5) + (this.customCarbHandfuls * 3) + (this.customFatThumbs * 2));
          carbs = (22 * this.customCarbHandfuls) + ((this.customProteinPalms * 2) + (this.customFistsVeggies * 5) + (this.customFatThumbs * 2));
          fats = (8 * this.customFatThumbs) + ((this.customProteinPalms * 4) + (this.customCarbHandfuls * 1));
        } else {
          normProtein = (24 * this.customProteinPalms) + ((this.customFistsVeggies * 1.5) + (this.customCarbHandfuls * 3) + (this.customFatThumbs * 2));
          carbs = (25 * this.customCarbHandfuls) + ((this.customProteinPalms * 2) + (this.customFistsVeggies * 5) + (this.customFatThumbs * 2));
          fats = (9 * this.customFatThumbs) + ((this.customProteinPalms * 4.5) + (this.customCarbHandfuls * 1));
        }

        this.customDietCalories = (normProtein * 4) + (carbs * 4) + (fats * 9);

        this.customProteinPercent = Math.round((4 * normProtein) / (.01 * this.customDietCalories));
        this.customCarbPercent = Math.round((4 * carbs) / (.01 * this.customDietCalories));
        this.customFatPercent = Math.round((9 * fats) / (.01 * this.customDietCalories));

        this.customDietFists = true;
      } else if (this.calculateCustomMacros) {
        normProtein = this.customProteinGrams;
        carbs = this.customCarbGrams;
        fats = this.customFatGrams;
      }
      // Calories = protein grams x 4 + carb grams x 4 + fat grams x 9
    }

    this.customDietCalories = (normProtein * 4) + (carbs * 4) + (fats * 9);

    if (this.goalCalsField < 1000 || (this.customDietCalories && this.customDietCalories < 1000)) {
      if (withWarnings) this.launchDialog('calsTooSmall');
    }

    // Handle negative values - throw errors and adjust

    var negGramsError = false;

    if (carbs < 0 && fats < 0) {
      negGramsError = true;
      carbs = 0;
      fats = 0;
      normProtein = Math.round(this.goalCalsField / 4);
    } else if (carbs < 0) {
      fats = 0;
      carbs = Math.round((this.goalCalsField - (normProtein * 4)) / 4);
      if (carbs < 0) {
        negGramsError = true;
        carbs = 0;
        normProtein = Math.round(this.goalCalsField / 4);
      }
    } else if (fats < 0) {
      carbs = 0;
      fats = Math.round((this.goalCalsField - (normProtein * 4)) / 9);
      if (fats < 0) {
        negGramsError = true;
        fats = 0;
        normProtein = Math.round(this.goalCalsField / 4);
      }
    }

    if (negGramsError) {
      if (withWarnings) this.launchDialog('negGrams');
    }

    this.totalProtein = Math.round(normProtein);
    this.perMealProtein = Math.round(normProtein / mpd);
    this.totalCarbs = carbs;
    this.perMealCarbs = Math.round(carbs / mpd);
    this.totalFats = fats;
    this.perMealFats = Math.round(fats / mpd);

    let fists;
    if (!this.customDietFists) {
      var lastPalms = 0,
        lastHandfuls = 0,
        lastThumbs = 0,
        palms = 0,
        handfuls = 0,
        thumbs = 0;

      fists = 7;

      if (this.genderBox == "Female") {
        fists = 5;
      }

      var iterations = 0;
      if (this.genderBox == "Female") {
        palms = (this.totalProtein - ((fists * 1.5) + (lastHandfuls * 3) + (lastThumbs * 2))) / 22;
        handfuls = (carbs - ((palms * 2) + (fists * 5) + (lastThumbs * 2))) / 22;
        thumbs = (fats - ((palms * 4) + (handfuls * 1))) / 8;
      } else {
        palms = (this.totalProtein - ((fists * 1.5) + (lastHandfuls * 3) + (lastThumbs * 2))) / 24;
        handfuls = (carbs - ((palms * 2) + (fists * 5) + (thumbs * 2))) / 25;
        thumbs = (fats - ((palms * 4.5) + (handfuls * 1))) / 9;
      }

      iterations++;

      while ((Math.abs(palms - lastPalms) > .05 || Math.abs(handfuls - lastHandfuls) > .05 || Math.abs(thumbs - lastThumbs) > .05) &&
        (iterations < 6)) {
        lastPalms = palms >= 0 ? palms : 0;
        lastHandfuls = handfuls >= 0 ? handfuls : 0;
        lastThumbs = thumbs >= 0 ? thumbs : 0;
        if (this.genderBox == "Female") {
          palms = (this.totalProtein - ((fists * 1.5) + (lastHandfuls * 3) + (lastThumbs * 2))) / 22;
          handfuls = (carbs - ((palms * 2) + (fists * 5) + (lastThumbs * 2))) / 22;
          thumbs = (fats - ((palms * 4) + (handfuls * 1))) / 8;
        } else {
          palms = (this.totalProtein - ((fists * 1.5) + (lastHandfuls * 3) + (lastThumbs * 2))) / 24;
          handfuls = (carbs - ((palms * 2) + (fists * 5) + (thumbs * 2))) / 25;
          thumbs = (fats - ((palms * 4.5) + (handfuls * 1))) / 9;
        }
        ++iterations;
      }

      palms = (palms < 0) ? 0 : palms;
      handfuls = (handfuls < 0) ? 0 : handfuls;
      thumbs = (thumbs < 0) ? 0 : thumbs;


      // fists are always the same unless we're using custom hand portions
      if (this.genderBox == "Male") {
        this.totalFists = "6 - 8";
      } else {
        this.totalFists = "4 - 6";
      }
    } else {
      palms = this.customProteinPalms;
      handfuls = this.customCarbHandfuls;
      thumbs = this.customFatThumbs;

      fists = this.totalFists = this.customFistsVeggies;
    }

    this.totalPalms = Math.round(palms);
    this.totalHandfuls = Math.round(handfuls);
    this.totalThumbs = Math.round(thumbs);

    this.perMealFists = this.roundRange(fists / mpd);
    this.perMealHandfuls = this.roundRange(this.totalHandfuls / mpd);
    this.perMealThumbs = this.roundRange(this.totalThumbs / mpd);
    this.perMealPalms = this.roundRange(this.totalPalms / mpd);

    if (this.customMacroAdjustType == "own") {
      this.finalCarbsPercentage = this.customCarbPercent;
      this.finalProteinPercentage = this.customProteinPercent;
      this.finalFatPercentage = this.customFatPercent
    } else {
      let recommendedPercentages = this.macroPercentageMapping[this.macroPreference];
      this.finalCarbsPercentage = recommendedPercentages.carbs;
      this.finalProteinPercentage = recommendedPercentages.protein;
      this.finalFatPercentage = recommendedPercentages.fat;
    }

    if (this.unachievableGoal) {
      this.goalCalsField = 0;
    }

    if (this.goalCalsField <= 0) {
      this.totalPalms = 0;
      this.totalHandfuls = 0;
      this.totalThumbs = 0;
      this.totalFists = 0;

      this.perMealFists = "0";
      this.perMealHandfuls = "0";
      this.perMealThumbs = "0";
      this.perMealPalms = "0";

      this.finalCarbsPercentage = 0;
      this.finalProteinPercentage = 0;
      this.finalFatPercentage = 0;

      this.totalProtein = 0;
      this.totalCarbs = 0;
      this.totalFats = 0;

      this.perMealCarbs = 0;
      this.perMealFats = 0;
      this.perMealProtein = 0;
    }

  }

  roundRange = (num) => {
    if (num == 0) {
      return "0";
    } else if (num < .5) {
      return "0 or 1";
    } else if ((num - Math.floor(num)) > 0) {
      return Math.floor(num) + " or " + Math.ceil(num);
    } else {
      return String(num);
    }
  }

  runCalculations = () => {
    this.goalChange();
    this.goForward();
  }

  getGoalWeight = () => {
    //return (this.weightUnitsRadioGroup == "lbs") ? this.goalWeight * this.weightunits : this.weightunits;
    return this.goalWeight;
  }

  skipWeight = () => {
    if (this.goalPreference != "Lose Weight" && this.goalPreference != "Build Muscle") {
      this.goalWeight = this.initialWeightField;
      this.goalTime = 365;
      return true;
    } else {
      return false;
    }
  }

  setupCustomMacroSliders = () => {
    let defaultMacros = this.macroPercentageMapping[this.dietMapping[this.dietaryPreference].validMacros[0]];
    this.customProteinPercent = defaultMacros.protein;
    this.customCarbPercent = defaultMacros.carbs;
    this.customFatPercent = defaultMacros.fat;
    this.totalCustomPercent = 100;

    this.updatePreviewMacroGrams();
  }

  updatePreviewMacroGrams = (tempVars:any = {}) => {
    this.customProteinGrams = Math.round((.01 * (tempVars.protein || this.customProteinPercent) * this.goalCalsField) / 4);
    this.customCarbGrams = Math.round((.01 * (tempVars.carbs || this.customCarbPercent) * this.goalCalsField) / 4);
    this.customFatGrams = Math.round((.01 * (tempVars.fat || this.customFatPercent) * this.goalCalsField) / 9);

  }

  miscDietSetups = () => {
    if (this.customMacroPercentages) {
      this.updatePreviewMacroGrams();
    }
  }

  sliderInput = (event: any, sliderVar) => {
    let eventValue = event.value;
    let thisDietVar = this[this.dietVarsMapping[sliderVar]];

    let range = this.dietMapping[this.dietaryPreference][sliderVar].limits[this.calcPath];

    if (eventValue < range.low) {
      eventValue = event.value = range.low;
    }

    if (eventValue > range.high) {
      eventValue = event.value = range.high;
    }

    this.lastMacroSliderValue = this.lastMacroSliderValue || thisDietVar;
    let updateParams = { balance: eventValue - this.lastMacroSliderValue };
    this.lastMacroSliderValue = updateParams[sliderVar] = event.source.value = event.value = eventValue;
    this.balanceMacroSliders(updateParams);
    this.updatePreviewMacroGrams(updateParams);
  }

  balanceMacroSliders = (update:any) => {
    if (update.balance == 0) return;

    let toggle = { fat: 'carbs', carbs: 'fat' };

    let ranges = {
      protein : this.dietMapping[this.dietaryPreference].protein.limits[this.calcPath],
      carbs : this.dietMapping[this.dietaryPreference].carbs.limits[this.calcPath],
      fat : this.dietMapping[this.dietaryPreference].fat.limits[this.calcPath]
    }

    let tryDecrement = (macro) => {
      if (this[this.dietVarsMapping[macro]] > ranges[macro].low ) {
        this[this.dietVarsMapping[macro]]--;
        return true;
      } else {
        return false;
      }
    }

    let tryIncrement = (macro) => {
      if (this[this.dietVarsMapping[macro]] < ranges[macro].high ) {
        this[this.dietVarsMapping[macro]]++;
        return true;
      } else {
        return false;
      }
    }

    while (update.balance != 0) {
      if (update.protein) {
        this.lastSliderAdjustment = this.lastSliderAdjustment || 'carbs';
        if (update.balance > 0) {
          tryDecrement(toggle[this.lastSliderAdjustment]) || tryDecrement(this.lastSliderAdjustment);
          update.balance--;
          this.lastSliderAdjustment = toggle[this.lastSliderAdjustment];
        } else {
          tryIncrement(toggle[this.lastSliderAdjustment]) || tryIncrement(this.lastSliderAdjustment);
          update.balance++;
          this.lastSliderAdjustment = toggle[this.lastSliderAdjustment];
        }
      } else if (update.carbs) {
        if (update.balance > 0) {
          tryDecrement('fat') || tryDecrement('protein');
          update.balance--;
        } else {
          tryIncrement('fat') || tryIncrement('protein');
          update.balance++;
        }
      } else if (update.fat) {
        if (update.balance > 0) {
          tryDecrement('carbs') || tryDecrement('protein');
          update.balance--;
        } else {
          tryIncrement('carbs') || tryIncrement('protein');
          update.balance++;
        }
      }
    }
  }

  sliderChange = (event, sliderVar) => {
    //this.sliderInput( event, sliderVar );
    this.lastMacroSliderValue = null;
    this.totalCustomPercent = Number(this.customProteinPercent) + Number(this.customFatPercent) + Number(this.customCarbPercent);
  }

  setMealStandard = () => {
    this.customMacroAdjustType = "recommendations"
    this.macroPreference = this.dietMapping[this.dietaryPreference].validMacros[0];
    this.goForward('meals');
  }

  getActivitySubtitle = () => {
    return this.WorkActivityLevel ? this.textHelperService.swapPronouns(this.contentData.activity.options.filter(option => option.value == this.WorkActivityLevel)[0].subtitle, this.calcPath) : '';
  }

  getDietSubtitle = () => {
    return this.dietaryPreference ? this.textHelperService.swapPronouns(this.contentData.diet.options.filter(option => option.value == this.dietaryPreference)[0].subtitle, this.calcPath) : '';
  }

  getMacroSubtitle = () => {
    if (this.macroPreference && Object.keys(this.macroPercentageMapping).includes(this.macroPreference)) {
      let p = this.contentData.macros.options.filter(option => option.value == this.macroPreference)[0];
      return `${p.tilda?'<span class="tilda">~</span>':''}${p.protein}% protein, ${p.tilda?'<span class="tilda">~</span>':''}${p.carbs}% carbs, ${p.tilda?'<span class="tilda">~</span>':''}${p.fats}% fats`
    } else {
      return '';
    }
  }

  getExerciseSubtitle = () => {
    return this.ExerciseLevel ? this.textHelperService.swapPronouns( this.contentData.exercise.options.filter(option => option.value == this.ExerciseLevel)[0].subtitle, this.calcPath) : '';
  }

  getGoalSubtitle = () => {
    return this.goalPreference ? this.textHelperService.swapPronouns(this.contentData.goal.options.filter(option => option.value == this.goalPreference)[0].subtitle, this.calcPath) : '';
  }

  enableCustomMacroPercentages = () => {
    this.setNormalMacros();
    this.macroPreference = "Customize Macro Percentages";
    this.customMacroAdjustType = "own";
    this.customMacroPercentages = true;
    this.goalChange(false);
    this.updatePreviewMacroGrams();
  }

  enableCustomMacroGrams = () => {
    this.setNormalMacros();
    this.customMacroAdjustType = "own";
    this.customMacroGrams = true;
  }

  enableCustomMacroPalms = () => {
    this.setNormalMacros();
    this.customMacroAdjustType = "own";
    this.customMacroPalms = true;
  }

  enableCalculateCustomMacros = () => {
    this.setNormalMacros();
    this.customMacroAdjustType = "own";
    this.calculateCustomMacros = true;
    this.customCarbGrams = this.customFatGrams = this.customProteinGrams = this.customProteinPercent = this.customFatPercent = this.customCarbPercent = null;
    this.goalChange(false);
  }

  setNormalMacros = () => {
    this.customMacroAdjustType = "recommendations";
    this.customMacroPercentages = false;
    this.customMacroGrams = false;
    this.customMacroPalms = false;
    this.calculateCustomMacros = false;
  }

  changeAgeField = () => {
    this.baselineChange();
    this.goalChange(false);
  }

  changeRmrInput = () => {
    if (this.rmrCalcAuto === "false") {
        this.rmrCalcDisabled = false;
        this.baseline.rmrCalc = true;
    } else {
        this.rmrCalcDisabled = true;
        this.baseline.rmrCalc = false;
    }
    this.baselineChange();
    this.goalChange(false);
  };

  changeRMRField = () => {
    this.baselineChange();
    this.goalChange();
  }

  baselineChange = () => {
    this.baseline.rmr = this.initialRMRField / this.energyunits;
    this.baseline.age = this.ageField;
    this.baseline.pal = this.initialPALField;

    if (this.ageField && (this.heightField || (this.heightFt && this.heightIn)) && this.initialWeightField && this.genderBox) {
      this.InitialBfpField = this.round10(this.baseline.getBFP(), -1);
    } else {
      this.InitialBfpField = null;
    }
    this.initialBfpField2 = this.round10(this.baseline.getBFP(), -1);

    this.initialBMIField = this.round10(this.baseline.getBMI(), -1);
    this.changeEnergyUnits();
  };

  changeEnergyUnits = () => {
    if (this.energyUnitsRadioGroup == "Calories/day") {
      //this.energyUnitsRadioGroupLbl = "Cal/day";
      this.energyUnitsLblSrt = "Calorie";
      this.energyunits = 1;

    } else {
      //this.energyUnitsRadioGroupLbl = "Kj/day";
      this.energyUnitsLblSrt = "Kilojoule";
      this.energyunits = 4.184;
    }
    this.maintCalsField = Math.round(this.baseline.getMaintCals() * this.energyunits);
    this.goalCalsField = Math.round(this.goalIntervention.calories * this.energyunits);
    this.goalMaintCalsField = Math.round(this.goalMaintenanceIntervention.calories * this.energyunits);
    if (this.ageField && (this.heightField || (this.heightFt && this.heightIn)) && this.initialWeightField && this.genderBox) {
      this.initialRMRField = Math.round(this.baseline.getRMR() * this.energyunits);
    } else {
      this.initialRMRField = null;
    }
    this.int1_calField = Math.round(this.int1.calories * this.energyunits);
    this.int2_calField = Math.round(this.int2.calories * this.energyunits);
  }

  changeBfpInput = function() {
      if (this.bfpCalcAuto === "true") {
          this.bfpCalcDisabled = true;
          this.baseline.bfpCalc = true;
          this.baseline.bfp = this.baseline.getBFP();
          this.goalChange();
      } else {
          this.bfpCalcDisabled = false;
          this.baseline.bfpCalc = false;
      }
      this.InitialBfpField = this.round10(this.baseline.bfp, -1);
      this.initialBfpField2 = this.InitialBfpField;
  };

  changeBfpField = () => {
    var check = this.InitialBfpField;
    if (check >= 0 && check <= 100 && check != this.baseline.bfp) {
        this.baseline.bfp = this.InitialBfpField;
        this.initialBfpField2 = this.InitialBfpField;
        this.goalChange();
    } else {
        this.InitialBfpField = this.baseline.bfp;
    }
  };

  setRecommendedFoods = () => {
    Object.keys( this.recommendedFoods ).forEach( mealPart => {
      if (this.dietaryPreference) {
        this.recommendedFoods[mealPart] = this.dietMapping[this.dietaryPreference][mealPart].foods.split(",").map( food => food.trim());
      }
    })

    this.getMacroOptions();
    this.setupCustomMacroSliders();
  }

  startSelfEdit = () => {
    this.selfEdit = true;
    this.goForward('proDetails');
  }

  pickResultsPage = () => {
    if ( this.selfEdit ) {
      this.goForward('results');
    } else {
      this.goForward('proResults');
    }
  }

  pdfTemplates: any = {
    self : 'assets/pdf/para053-pn-calc-output-enduser-v7-s.pdf',
    selfWithProCopy : 'assets/pdf/selfpro-v7-w.pdf',
    pro : 'assets/pdf/fitpro-v7-ex-c.pdf'
    //pro : 'assets/pdf/imagetest.pdf'
  }

  public processCaptcha(): void {

    this.capitalizeNames();

    this.recaptchaV3Service.execute(this.captchaID)
      .subscribe((token) => {
        this.captchaToken = token
        this.submitEmail();
      });

    this.pdfGenerationDone = false;
    this.goForward();

    setTimeout( ()=> {
      this.PDF.createPDF( this, this.onPDFGenComplete );
    }, 500);

  }

  fileChanged(e) {
    this.logoFile = e.target.files[0];
    this.logoFileDisplay = "..." + e.target.value.substr(e.target.value.length - 10);
  }

  convertURI = (URI) => {
    var BASE64_MARKER = ';base64,';

    function convertDataURIToBinary(dataURI) {
      var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
      var base64 = dataURI.substring(base64Index);
      var raw = window.atob(base64);
      var rawLength = raw.length;
      var array = new Uint8Array(new ArrayBuffer(rawLength));

      for(let i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i);
      }
      return array;
    }

    return convertDataURIToBinary(URI);
  }

  processLogo = () => {
    if (this.logoFile) {
      let fileReader = new FileReader();
      fileReader.onload = (e) => {

        var image = new Image();
        image.src = String(e.target['result']);

        image.onload = () => {
          let canvas = <HTMLCanvasElement>document.getElementById('logoCanvas');
          let ctx = canvas.getContext('2d');
          ctx.canvas.width = 480;
          ctx.canvas.height = 160;
          ctx.fillStyle = "white";
          ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);

          let ratio = image.width / image.height;
          let newWidth, newHeight;
          if (ratio >= 3) { // wider than 150 / 50, wider than tall
            newWidth = 480;
            newHeight = Math.round(480 / ratio);
          } else { // taller than 150 / 50
            newHeight = 160;
            newWidth = Math.round(160 * ratio);
          }
           ctx.drawImage(image, 0, 0, image.width, image.height,     // source rectangle
             0, 0, newWidth, newHeight); // destination rectangle
          this.PDF.logoData = {
            width: newWidth,
            height: newHeight,
            data: this.convertURI(ctx.canvas.toDataURL('image/jpeg'))
          }
          this.processPDF();
        };
      }
      fileReader.readAsDataURL(this.logoFile);
    } else {
      this.processPDF();
    }
  }

  processPDF = (): void => {
    this.pdfGenerationDone = false;
    this.goForward();

    setTimeout( ()=> {
      this.PDF.createPDF( this, this.onPDFGenComplete );
    }, 500);
  }

  submitEmail = () => {
    //this.registerService.submit( this.calcPath == 'self' ? this.userName : this.coachName, this.userEmail, this.captchaToken);
    this.capitalizeNames();
    window.parent.postMessage({ "operation": "signup", "first_name": this.calcPath == 'self' ? this.userName : this.coachName, "email": this.userEmail }, '*');
  }

  getMacroOptions = () => {
    if (this.dietaryPreference) {
      this.filteredMacroOptions = this.contentData.macros.options.filter( op => {
        return this.dietMapping[ this.dietaryPreference ].validMacros.includes(op.value);
      });

      let allDietOptions = ["Customize Macro Percentages", "Customize Macro Grams", "Enter Desired Macro Totals", "Enter Desired Hand Portions", ...this.filteredMacroOptions.map(op => op.value)];

      if (!allDietOptions.includes(this.macroPreference)) {
        setTimeout(()=>{
          //this.macroPreference = this.filteredMacroOptions[0].value;
          //this.macroPreference = null;
          const macroPrefControl = this.proDietForm.get('macroPref');
          macroPrefControl.setValue(null);
          macroPrefControl.updateValueAndValidity();
        },100)
      }
    }
  }

  formatSliderLabel = (value: number) => {
    return value + '%';
  }

  getLowestMacroPercentage = () => {
    Math.min(this.dietMapping[this.dietaryPreference].protein.limits[this.calcPath].low, this.dietMapping[this.dietaryPreference].carbs.limits[this.calcPath].low, this.dietMapping[this.dietaryPreference].fat.limits[this.calcPath].low);
  }

  getHighestMacroPercentage = () => {
    Math.max(this.dietMapping[this.dietaryPreference].protein.limits[this.calcPath].high, this.dietMapping[this.dietaryPreference].carbs.limits[this.calcPath].high, this.dietMapping[this.dietaryPreference].fat.limits[this.calcPath].high);
  }

  increment = (someVar) => {
    this[someVar]++;
  }
  decrement = (someVar) => {
    this[someVar]--;
  }

  onPDFGenComplete = (pdfBlob) => {
    let anchor = document.createElement("a");

    anchor.href = pdfBlob;
    anchor.download = 'PrecisionNutrition-MacroPortionCalculations.pdf';
    anchor.click();

    this.pdfGenerationDone = true;
  }

  capitalizeNames = () => {
    if (this.userName) {
      this.userName = this.titleCase(this.userName);
    }

    if (this.calcPath == 'selfWithProCopy' && this.coachName) {
      this.coachName = this.titleCase(this.coachName);
    }
  }

  titleCase = (input) => {
    return input.replace(/[^-'\s]+/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
  }

  calcCustomMacros = () => {
    let convFactor = ((this.weightUnitsRadioGroup=='lbs')? 1 : 2.2) / ((this.custMacCalcGramPer=='glb')? 1 : 2.2);

    if (this.custMacroCalcProtMultiplier) {
      this.customProteinGrams = Math.round(this.custMacroCalcProtMultiplier * this.initialWeightField * convFactor);
      this.customProteinPercent = Math.round((4 * this.customProteinGrams) / (.01 * this.goalCalsField));
    }

    if (this.custMacCalcCombo=='ProteinCarb') {
      if (this.custMacroCalcCarbMultiplier) this.customCarbGrams = Math.round(this.custMacroCalcCarbMultiplier * this.initialWeightField * convFactor);
      if (this.customProteinGrams && this.customCarbGrams) {
        this.customFatGrams = Math.round((this.goalCalsField - (this.customProteinGrams * 4) - (this.customCarbGrams * 4)) / 9);
        if (this.customFatGrams < 0) this.customFatGrams = 0;
      }
    } else {
      if (this.custMacroCalcFatMultiplier) this.customFatGrams = Math.round(this.custMacroCalcFatMultiplier * this.initialWeightField * convFactor);
      if (this.customProteinGrams && this.customFatGrams) {
        this.customCarbGrams = Math.round((this.goalCalsField - (this.customProteinGrams * 4) - (this.customFatGrams * 9)) / 4);
        if (this.customCarbGrams < 0) this.customCarbGrams = 0;
      }
    }

    if (typeof this.customCarbGrams != "undefined" && this.customCarbGrams != null) this.customCarbPercent = Math.round((4 * this.customCarbGrams) / (.01 * this.goalCalsField));
    if (typeof this.customFatGrams != "undefined" && this.customFatGrams != null) this.customFatPercent = Math.round((9 * this.customFatGrams) / (.01 * this.goalCalsField));

    this.remainingCals = Math.round(this.goalCalsField - (4 * (this.customProteinGrams || 0)) - (4 * (this.customCarbGrams || 0)) - (9 * (this.customFatGrams || 0)));
  }

  updateGoalProjections = () => {
    // this.goalWeight
    // this.initialWeightField
    // this.goalPreference
    // weight loss: (Start Weight - Goal Weight) / (Rate * ((Goal Weight + Start Weight) / 2))
    // Formula = (Goal Weight - Start Weight) / (Rate * ((Goal Weight + Start Weight) / 2))
    let formulaNumerator = {
      'Lose Weight': this.initialWeightField - this.goalWeight,
      'Build Muscle': this.goalWeight - this.initialWeightField
    }

    if (this.goalPreference=='Build Muscle') {
      this.goalProjection[this.goalPreference][this.genderBox].forEach( range => {
        range.from = Math.round(formulaNumerator[ this.goalPreference ] /
          (range.fromFactor * ((this.goalWeight + this.initialWeightField) / 2)));
        range.to = Math.round(formulaNumerator[ this.goalPreference ] /
          (range.toFactor * ((this.goalWeight + this.initialWeightField) / 2)));
      })
    } else if (this.goalPreference=='Lose Weight') {
      this.goalProjection[this.goalPreference][this.genderBox].forEach( range => {
        range.to = Math.round(formulaNumerator[ this.goalPreference ] /
          (range.fromFactor * ((this.goalWeight + this.initialWeightField) / 2)));
        range.from = Math.round(formulaNumerator[ this.goalPreference ] /
          (range.toFactor * ((this.goalWeight + this.initialWeightField) / 2)));
      })
    }
  }

  clearSlideStack = () => {
    this.slideStack = [];
  }

  initiateProPathway = () => {
    this.selfEdit=false;
    this.calcPath = this.trueProPathAllowed ? 'pro' : 'selfWithProCopy';
    this.goForward( this.trueProPathAllowed ? 'proDetails' : 'age');
    // for debugging true pro path only!
    //this.goForward( this.trueProPathAllowed ? 'proResults' : 'age');
    this.PDF.downloadPDF(this.pdfTemplates[ this.calcPath ]);
  }

  initiateSelfPathway = () => {
    this.calcPath='self';
    this.goForward('age');
    this.PDF.downloadPDF(this.pdfTemplates[ this.calcPath ]);
  }

  get isSelfPath() {
    return this.calcPath === 'self';
  }

  get isCustomMacros() {
    return this.customMacroAdjustType !== 'recommendations';
  }

}
